// extracted by mini-css-extract-plugin
export default {"checkboxContainer":"styles_checkboxContainer__QDaBx","personalData":"styles_personalData__vW98m","label":"styles_label__2MeKI"};